import React from "react";
import  {Switch,Redirect} from "react-router-dom";
import { ContentRoute } from "../../../components/ContentRoute/ContentRoute";
import {PatientDetail} from "./patient-detail"

const Patient =()=>{
    return(
        <Switch>
            <ContentRoute path="/patient/:patientId" component={PatientDetail} />
            <Redirect from="/patient" to="/patient/:patientId" />
        </Switch>
    
    );
}

export default Patient;